import React, { Component } from 'react';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TravcoMasterdataAutocomplete } from 'travco-masterdata-autocomplete';
import { TravcoHotelAutocomplete } from 'travco-hotel-autocomplete';
import { TravcoDateRangePicker } from 'travco-date-range-picker';
import {Integer} from 'travco-input-number';

class SearchView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAdvanceSearch: false
        };
        this.onAdvanceSearchClick = this.onAdvanceSearchClick.bind(this);
    }

    onAdvanceSearchClick() {
        this.setState((cState) => {
            return { showAdvanceSearch: !cState.showAdvanceSearch };
        });
    }

    render() {
        const {
            onCountryChange,
            onRegionChange,
            onCityChange,
            onLocationChange,
            onHotelChange,
            onDatesChange,
            onRoomAmountChange,
            onSearch,
            onClearForm,
            hasError,
            selectedHotel,
            selectedCountry,
            selectedCountryRegion,
            selectedCity,
            selectedLocation,
            roomsAmount: { extraBeds, quad, triple, double, single },
            dates: { checkIn, checkOut },
            isLoading,
            token
        } = this.props;

        return (
            <div>
                <div className="travco-search-wrapper">
                    <div className="travco-body">
                        <div className="travco-grid-fluid gutter">
                            <div className="tg-cell">
                                <div className="content">
                                    <h1>Hotel Availability Search</h1>
                                </div>
                            </div>
                        </div>
                        <div className="travco-grid-fluid gutter">
                            <div className="tg-cell">
                                <div className="content">
                                    <TravcoMasterdataAutocomplete
                                        css="search-country"
                                        masterdataType="Country"
                                        masterdataApiUrl=""
                                        onChange={onCountryChange}
                                        searchable={true}
                                        clearable={true}
                                        selectedValue={selectedCountry ? selectedCountry.id : null}
                                        disabled={
                                            (!!selectedCountryRegion && this.state.showAdvanceSearch) || !!selectedCity
                                        }
                                        label="Country"
                                        token={token}
                                        id="country-input"
                                    />
                                    {this.state.showAdvanceSearch && (
                                        <TravcoMasterdataAutocomplete
                                            css="search-region"
                                            masterdataType="CountryRegion"
                                            masterdataApiUrl=""
                                            onChange={onRegionChange}
                                            searchable={true}
                                            selectedValue={selectedCountryRegion ? selectedCountryRegion.id : null}
                                            clearable={true}
                                            countryId={!!selectedCountry ? selectedCountry.id : null}
                                            disabled={!!selectedCity}
                                            label="Region"
                                            token={this.props.token}
                                            error={hasError.region ? '*Region is required' : null}
                                        />
                                    )}
                                    <TravcoMasterdataAutocomplete
                                        css="search-city"
                                        masterdataType="City"
                                        masterdataApiUrl=""
                                        onChange={onCityChange}
                                        searchable={true}
                                        clearable={true}
                                        countryId={selectedCountry != null ? selectedCountry.id : null}
                                        countryRegionId={
                                            selectedCountryRegion != null ? selectedCountryRegion.id : null
                                        }
                                        label="City"
                                        selectedValue={selectedCity ? selectedCity.id : null}
                                        disabled={!!selectedLocation || !!selectedHotel}
                                        token={token}
                                        error={
                                            hasError.city && !this.state.showAdvanceSearch ? '*City is required' : null
                                        }
                                    />
                                    {this.state.showAdvanceSearch && (
                                        <TravcoMasterdataAutocomplete
                                            css="search-region"
                                            masterdataType="CityArea"
                                            masterdataApiUrl=""
                                            onChange={onLocationChange.bind(this)}
                                            searchable={true}
                                            clearable={true}
                                            cityId={selectedCity != null ? selectedCity.id : null}
                                            label="Area"
                                            selectedValue={selectedLocation ? selectedLocation.id : null}
                                            disabled={!selectedCity || !!selectedHotel}
                                            token={token}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="tg-cell-2-8">
                                <div className="content">
                                    <TravcoDateRangePicker
                                        block
                                        small
                                        minimumNights={1}
                                        endDate={checkOut}
                                        onDatesChange={onDatesChange}
                                        startDate={checkIn}
                                        required
                                        label="Dates"
                                        className="search-dates"
                                        error={hasError.dates ? '*Please insert a valid format date DD/MM/YYYY' : null}
                                    />
                                    <TravcoHotelAutocomplete
                                        className="search-hotel"
                                        onChange={onHotelChange}
                                        country={selectedCountry}
                                        city={selectedCity}
                                        searchable={true}
                                        clearable={true}
                                        selectedHotel={selectedHotel}
                                        token={token}
                                        label="Hotel"
                                        id="hotel-input"
                                    />
                                </div>
                            </div>
                            <div className="tg-cell-2-5">
                                <div className={`content ts-room ${hasError.rooms ? 'warning' : ''}`}>
                                    <div className="ts-room-type extra-bed">
                                        <Integer
                                            label="Double/Twin"
                                            onChange={onRoomAmountChange.bind(this, 'double')}
                                            min={0}
                                            max={5}
                                            controls
                                            value={double}
                                            className="search-room-double"
                                        />
                                        <span className="ts-room-type-plus">+</span>
                                        <Integer
                                            label="Extra Beds*"
                                            onChange={onRoomAmountChange.bind(this, 'extraBeds')}
                                            min={0}
                                            max={double}
                                            controls
                                            value={extraBeds}
                                            className="search-room-extra"
                                            disabled={double == 0}
                                        />
                                        <span className={hasError.rooms ? ' no-show' : 'ts-room-type-note' }>
                                            *Extra bed is for 1 child (under 12 years)
                                        </span>
                                    </div>
                                    <div className="ts-room-type">
                                        <Integer
                                            label="Single"
                                            onChange={onRoomAmountChange.bind(this, 'single')}
                                            min={0}
                                            max={6}
                                            controls
                                            value={single}
                                            className="search-room-single"
                                        />
                                    </div>
                                    {this.state.showAdvanceSearch && (
                                        <div>
                                            <div className="ts-room-type">
                                                <Integer
                                                    label="Triple"
                                                    onChange={onRoomAmountChange.bind(this, 'triple')}
                                                    min={0}
                                                    max={4}
                                                    controls
                                                    value={triple}
                                                    className="search-room-triple"
                                                />
                                            </div>
                                            <div className="ts-room-type" />
                                            <div className="ts-room-type" style={{ marginLeft: '26px' }}>
                                                <Integer
                                                    label="Quad"
                                                    onChange={onRoomAmountChange.bind(this, 'quad')}
                                                    min={0}
                                                    max={3}
                                                    controls
                                                    value={quad}
                                                    className="search-room-quad"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {hasError.rooms && <span className="ts-warning-label">{hasError.rooms}</span>}
                                </div>
                            </div>

                            <div className="tg-cell-1-8">
                                <div className="content">
                                    <button
                                        className="travco-btn-primary"
                                        type="button"
                                        onClick={onSearch}
                                        disabled={isLoading}>
                                        Search
                                    </button>
                                    <button className="travco-btn-tertiary" onClick={onClearForm}>
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ts-action-expand">
                    <span
                        className={`ts-search-advance-btn ${this.state.showAdvanceSearch ? 'open' : ''}`}
                        onClick={this.onAdvanceSearchClick}>
                        {this.state.showAdvanceSearch ? 'Fewer Options' : 'More Options'}
                    </span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const isLoading = state.pendingTasks > 0;
    return {
        isLoading
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchView);
